import http from "@/settings/apiSettings";

class DOC_EticheteDataService {
    getByLinie(linieId: string): Promise<any> {
        return http.clientDocumente.get(`/DOC_Etichete/linie/${linieId}`);
    }

    genereaza(linieId: string, overwrite = false): Promise<any> {
        return http.clientDocumente.post(`/DOC_Etichete/genereaza/${linieId}?overwrite=${overwrite}`);
    }

    genereazaToate(documentId: string): Promise<any> {
        return http.clientDocumente.post(`/DOC_Etichete/genereaza-toate/${documentId}`);
    }

    scaneaza(data: {
        DocumentId: string;
        ProdusId?: string | null;
        CantitateScanata: number;
        CodBare: string;
        Intrare?: boolean;
        Iesire?: boolean;
    }): Promise<any> {
        return http.clientDocumente.post(`/DOC_Etichete/scaneaza`, data);
    }

    marcheazaTiparit(id: string): Promise<any> {
        return http.clientDocumente.post(`/DOC_Etichete/${id}/marcheaza-tiparit`);
    }

    getDisponibile(produsId: string, gestiuneId: string): Promise<any> {
        return http.clientDocumente.get(`/DOC_Etichete/disponibile?produsId=${produsId}&gestiuneId=${gestiuneId}`);
    }

    getScanari(documentId: string): Promise<any> {
        return http.clientDocumente.get(`/DOC_Etichete/scanari/${documentId}`);
    }
}
export default new DOC_EticheteDataService();
